import React, { useEffect, useState } from 'react';
import KeyboardShortcutsDialog from './KeyboardShortcutsDialog';

export default function GlobalKeyboardShortcuts() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key !== '?') return;
      const t = e.target;
      if (
        t &&
        (t.tagName === 'INPUT' ||
          t.tagName === 'TEXTAREA' ||
          t.tagName === 'SELECT' ||
          (t.closest && t.closest('[contenteditable="true"]')))
      ) {
        return;
      }
      e.preventDefault();
      setOpen(true);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return <KeyboardShortcutsDialog open={open} onClose={() => setOpen(false)} />;
}
